import { render } from "./Founders.vue?vue&type=template&id=6b0d4213"
import script from "./Founders.vue?vue&type=script&lang=js"
export * from "./Founders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__